import { DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core'

import { ConversationStore } from '@app/modules/messaging/components/store/conversation.store'
import { UIModule } from '@app/modules/ui/ui.module'

import { VoiceMessageRecorderStore } from '../voice-message-recorder/voice-message-recorder.store'

@Component({
  selector: 'sb-voice-message-creator-exit-confirm',
  templateUrl: './voice-message-creator-exit-confirm.component.html',
  imports: [UIModule, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoiceMessageCreatorExitConfirmComponent {
  readonly conversationStore = inject(ConversationStore)
  readonly voiceMessageRecorderStore = inject(VoiceMessageRecorderStore)

  readonly duration = input<number | undefined>()
  confirmExit = output<void>()

  attemptToSendMessage(): void {
    const voice = this.conversationStore.voice()

    if (voice) {
      this.voiceMessageRecorderStore.attemptToSendMessage(voice, this.voiceMessageRecorderStore.boosted())
    }
  }
}
